import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative bg-gradient-to-br from-primary/10 via-background to-secondary/10 py-20 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-6">
            <Icon name="ShieldCheckIcon" size={20} className="text-accent" variant="solid" />
            <span className="text-sm font-semibold text-accent">Regulatory Excellence, Delivered</span>
          </div>
          
          <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-textPrimary mb-6 leading-tight">
            Navigate Global Regulatory Landscapes with Confidence
          </h1>
          
          <p className="text-lg md:text-xl text-textSecondary mb-8 leading-relaxed max-w-3xl mx-auto">
            Expert consultancy services ensuring seamless market entry, compliance excellence, and regulatory success across 60+ countries. Your strategic partner for pharmaceutical regulatory mastery.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button className="w-full sm:w-auto px-8 py-4 bg-cta text-cta-foreground font-cta font-semibold text-base rounded-md hover:-translate-y-1 hover:shadow-cta transition-all duration-300 flex items-center justify-center space-x-2">
              <span>Request Consultation</span>
              <Icon name="ArrowRightIcon" size={20} />
            </button>
            <a 
              href="https://docs.google.com/spreadsheets/d/1SG3zdQOSxDPFtAivVNkeNRIRocVDwIp1Nk5R_UbjaRY/edit?usp=sharing" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-8 py-4 bg-card text-textPrimary font-semibold text-base rounded-md border-2 border-border hover:border-primary hover:bg-muted transition-all duration-300 flex items-center justify-center space-x-2"
            >
              <Icon name="DocumentTextIcon" size={20} />
              <span>Download Compliance Guide</span>
            </a>
          </div>
          
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { value: '60+', label: 'Countries Served', icon: 'GlobeAltIcon' },
              { value: '500+', label: 'Successful Projects', icon: 'CheckBadgeIcon' },
              { value: '98%', label: 'Approval Rate', icon: 'ChartBarIcon' },
              { value: '15+', label: 'Years Experience', icon: 'AcademicCapIcon' }
            ].map((stat, index) => (
              <div key={index} className="bg-card/50 backdrop-blur-sm p-6 rounded-lg border border-border">
                <Icon name={stat.icon as any} size={32} className="text-primary mx-auto mb-3" variant="solid" />
                <div className="font-heading font-bold text-3xl text-textPrimary mb-1">{stat.value}</div>
                <div className="text-sm text-textSecondary">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;